import { HorizontalRule } from '@mui/icons-material';
import { addExtraItem, removeItem } from '../utils/order-actions';
import { Add } from '@mui/icons-material';
import IProductOption from '../interfaces/IProductOption';
import IProduct from '../interfaces/IProduct';
import MealModal from './modals/meal-modal';
import * as React from 'react';
import { ActionIconButtonGrey, ActionIconButtonPlus } from '../utils/action-button';

export default function CartItem(props: { cart: IProduct[]; product: IProduct; setCartState?: any; isOrderPage: any; }) {
    const [open, setOpen] = React.useState(false);
    const product = props.product;
    const cart = props.cart;
    const setCartState = props.setCartState;
    const isOrderPage = props.isOrderPage;

    const calculatedPrice = () => {
        let totalPriceForOptions = 0;
        if (product.optionGroups.length > 0) {
            product.optionGroups[0].options.forEach((option) => {
                totalPriceForOptions += option.price;
            })
        }

        return ((product.price + totalPriceForOptions) * product.quantity).toFixed(2).replace(".", ",");
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = (prod: IProduct) => {
        console.log('todo add item', prod)
    }

    const handleClickOpen = () => {
        //TODO bug fix van key en quantity meenemen
        setOpen(true);
    };

    return (
        <div>
            <div className="flex py-4">
                <div className="item-quantity">{product.quantity}</div>
                <div className="w-full">
                    <div className="flex justify-between">
                        <div className="w-3/5">
                            <div className="font-bold underline cursor-pointer" onClick={handleClickOpen}>{product.name}</div>
                            {/*{open ?*/}
                            {/*    <MealModal*/}
                            {/*        open={open}*/}
                            {/*        //@ts-ignore*/}
                            {/*        isEditing={true}*/}
                            {/*        onAdd={handleAdd}*/}
                            {/*        onClose={handleClose}*/}
                            {/*        product={product}*/}
                            {/*        setCart={setCartState}*/}
                            {/*        cart={cart} />*/}
                            {/*    : null}*/}
                            <div className="item-options">
                                {product.optionGroups.length > 0 &&
                                    product.optionGroups[0].options.map((option, i, row: IProductOption[]) =>
                                    <span key={option.id}>{option.name}{i + 1 !== row.length && ","} </span>
                                )}
                            </div>
                        </div>
                        <div className="item-pricing w-2/5">
                            <div className="flex justify-end">€{calculatedPrice()}</div>
                            {isOrderPage &&
                                <div className="pl-5 md:pl-3 flex justify-between pt-4">
                                    <ActionIconButtonGrey
                                        onClick={() => removeItem(setCartState, product)}
                                        variant="contained"
                                        color="">
                                        <HorizontalRule />
                                    </ActionIconButtonGrey>
                                    <ActionIconButtonPlus
                                        onClick={() => addExtraItem(setCartState, product)}
                                        variant="contained"
                                        color="secondary">
                                        <Add />
                                    </ActionIconButtonPlus>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </div>
    )
}